<script>
  import Tree from './Tree.svelte'
  import { getKramerius, setKramerius } from './logic'
  import { logged } from './stores'
  
  let uuid = '' //'uuid:bedd2dd0-1b62-11e6-b5a5-005056825209' //'uuid:4d50da70-11eb-11e6-a7f7-005056827e51' //'uuid:a2b8ea50-1b75-11e6-b992-5ef3fc9bb22f'
  let json
  let state = ''
  let description = ''
  let mode = 'manual'
  
  async function get() {
    json = undefined
    state = 'waiting ...'
    json = await getKramerius(uuid, 'mzk')
    console.log('get kram', json)
    uuid = '', state = ''
  }

  async function send() {
    const res = await setKramerius(json, time, description, $logged, mode)
    console.log('res', res)
    if (res) {
      if (!res.msg) {
        json = '';
        state = 'úspěšně zadáno ke zpracování'
      } else {
        json = res
      }
    }
  }

  const d = new Date()
  d.setHours(25,0,0,0)  // d.setHours(24 + d.getHours()%6, 0, 0, 0)
  const time = `${d.getDate()}.${('0'+(d.getMonth()+1)).slice(-2)}.${d.getFullYear()} 01:00:00`
</script>
 
<!-- {mode} -->
<div>
  <span class="font-medium">UUID:</span>
  <input type="text" class="input mx-1.5" bind:value={uuid} size="42" />
  <button type="button" class="btn btn-green" on:click={get}>OK</button>
  {state}
</div>

<hr class="my-4"/>

{#if json?.msg}
  <div class="error">{json.msg}</div>
{:else if json}
  <!-- {JSON.stringify(json)} -->
  {json.uuid}
  <Tree name={json.name} bind:items={json.children} expanded 
    onInfo={u => uuid = u} 
  />  
  
  <hr class="my-4"/>
  
  <div class="grid grid-cols-[auto_1fr] gap-2 items-center w-1/2">
    Mód:
    <select class="select" bind:value={mode}>
      <option value="manual">Manuální</option>
      <option value="automatic">Automatický</option>
    </select>
    Popis:
    <input type="text" class="input" bind:value={description} size="75" />
    &nbsp;
    <div class="justify-self-center">
      Datum a čas spuštění: <span class="font-medium">{time}</span>
      <button type="button" class="btn btn-green" on:click={send}>Zpracuj</button>
    </div>
  </div>
{/if}

<style>
  /* div {
    margin-bottom: 1em;
  } */

  /* .exec {
    float: right;
  } */

  /* .error {
    color: red;
    margin-left: 0.5em;
  } */

  /* input[type=text] {
    margin-left: 3px;
    margin-right: 3px;
  } */
</style>


